import type { IHeroImage } from "InterfacesTypes/interfaces";
import { IMAGESECTIONS } from "../../InterfacesTypes/enums";
import { getEnvironment, getImageBySection } from "../../utils/utils";

const HeroImagesSection = ({ imageItems }: { imageItems: IHeroImage[] }) => {
  const env = getEnvironment();

  const leftImg = getImageBySection(imageItems, IMAGESECTIONS.LEFT_IMAGE);

  const rightImgTopLeft = getImageBySection(
    imageItems,
    IMAGESECTIONS.RIGHT_IMG_TOP_LEFT
  );
  const rightImgTopRight = getImageBySection(
    imageItems,
    IMAGESECTIONS.RIGHT_IMG_TOP_RIGHT
  );

  const rightImgBottomLeft = getImageBySection(
    imageItems,
    IMAGESECTIONS.RIGHT_IMG_BOTTOM_LEFT
  );
  const rightImgBottomRight = getImageBySection(
    imageItems,
    IMAGESECTIONS.RIGHT_IMG_BOTTOM_RIGHT
  );
  return (
    <div className="grid grid-cols-2 grid-rows-2 [aspect-ratio:2/1] !mt-0">
      {leftImg && (
        <figure className="relative row-span-2 !m-0 !mr-[2px] overflow-hidden">
          <a href={leftImg?.Link} className="relative group">
            <img
              src={`${env.imageUrl}/${leftImg?.ImageUrl}`}
              alt={leftImg?.ImageText}
              className="w-full h-full !object-cover transform transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/50 transition-opacity duration-300 group-hover:opacity-0"></div>
            <span className="absolute left-1/2 top-[50%] -translate-x-1/2 -translate-y-1/2 !text-white text-base hover:!underline">
              {leftImg?.ImageText}
            </span>
          </a>
        </figure>
      )}

      <figure className="relative flex justify-around m-0">
        <a
          href={rightImgTopLeft?.Link}
          className="relative group w-[50%] !mx-[2px] !mb-[1px] overflow-hidden"
        >
          <img
            id="rightImgTopLeft"
            src={`${env.imageUrl}/${rightImgTopLeft?.ImageUrl}`}
            alt={rightImgTopLeft?.ImageText}
            className="w-full h-full !object-cover transform transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/50 transition-opacity duration-300 group-hover:opacity-0"></div>
          <span className="absolute left-[10%] bottom-[10%]  !text-white text-base leading-none hover:!underline">
            {rightImgTopLeft?.ImageText}
          </span>
        </a>
        <a
          href={rightImgTopRight?.Link}
          className="relative group w-[50%] !mx-[2px] !mb-[1px] overflow-hidden"
        >
          <img
            id="rightImgTopRight"
            src={`${env.imageUrl}/${rightImgTopRight?.ImageUrl}`}
            alt={rightImgTopRight?.ImageText}
            className="w-full h-full !object-cover transform transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/50 transition-opacity duration-300 group-hover:opacity-0"></div>
          <span className="absolute left-[10%] bottom-[10%]  !text-white text-base leading-none hover:!underline">
            {rightImgTopRight?.ImageText}
          </span>
        </a>
      </figure>

      <figure className="relative flex justify-around m-0 !mt-[3px]">
        <a
          href={rightImgBottomLeft?.Link}
          className="relative group w-[50%] !mx-[2px]  overflow-hidden"
        >
          <img
            src={`${env.imageUrl}/${rightImgBottomLeft?.ImageUrl}`}
            alt={rightImgBottomLeft?.ImageText}
            id="rightImgBottomLeft"
            className="w-full h-full !object-cover transform transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/50 transition-opacity duration-300 group-hover:opacity-0"></div>
          <span className="absolute left-[10%] bottom-[10%] !text-white text-base leading-none hover:!underline">
            {rightImgBottomLeft?.ImageText}
          </span>
        </a>
        <a
          href={rightImgBottomRight?.Link}
          className="relative group w-[50%] !mx-[2px]  overflow-hidden"
        >
          <img
            src={`${env.imageUrl}/${rightImgBottomRight?.ImageUrl}`}
            alt={rightImgBottomRight?.ImageText}
            id="rightImgBottomRight"
            className="w-full h-full !object-cover transform transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/50 transition-opacity duration-300 group-hover:opacity-0"></div>
          <span className="absolute left-[10%] bottom-[10%] !text-white text-base leading-none hover:!underline">
            {rightImgBottomRight?.ImageText}
          </span>
        </a>
      </figure>
    </div>
  );
};
export default HeroImagesSection;
